export const GENERAL_INFORMATION_READY = 'GENERAL_INFORMATION_READY';

export const EXPRESS_CONFIGURATION_READY = 'EXPRESS_CONFIGURATION_READY';

export const CREATE_USER_REQUEST = 'CREATE_USER_REQUEST';

export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';

export const CREATE_USER_FAILURE = 'CREATE_USER_FAILURE';

export const GET_USERS_REQUEST = 'GET_USERS_REQUEST';

export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';

export const GET_USERS_FAILURE = 'GET_USERS_FAILURE';

export const GET_USER_REQUEST = 'GET_USER_REQUEST';

export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';

export const GET_USER_FAILURE = 'GET_USER_FAILURE';

export const CLEAN_USERS = 'CLEAN_USERS';

export const CLEAN_USER = 'CLEAN_USER';

export const SET_TOTAL_USERS = 'SET_TOTAL_USERS';

export const DELETE_USER_REQUEST = 'DELETE_USER_REQUEST';

export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';

export const DELETE_USER_FAILURE = 'DELETE_USER_FAILURE';

export const GET_TELEPHONY_PROFILES_REQUEST = 'GET_TELEPHONY_PROFILES_REQUEST';

export const GET_TELEPHONY_PROFILES_SUCCESS = 'GET_TELEPHONY_PROFILES_SUCCESS';

export const GET_TELEPHONY_PROFILES_FAILURE = 'GET_TELEPHONY_PROFILES_FAILURE';

export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST';

export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';

export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE';

export const COPY_IP = 'COPY_IP';
